import { CampaignData } from 'modules/experiments/takeover/types';

const getTakeoverState = (state: Record<string, any>) => state.experiments.takeover;

export const getCampaignInfoState = (state: Record<string, any>) =>
  getTakeoverState(state).campaignInfo as CampaignData;
